export const GET_PORTAL_NOTIFICATIONS = "notification/GET_PORTAL_NOTIFICATIONS"
export const NOTIFICATION_CALLBACK = "notification/NOTIFICATION_CALLBACK"
export const MARK_AS_READ = "notification/MARK_AS_READ"
export const GET_PORTAL_NOTIFICATIONS_INITIAL = "notification/GET_PORTAL_NOTIFICATIONS_INITIAL"
export const MARK_CATEGORY_AS_READ = "notification/MARK_CATEGORY_AS_READ"
export const SET_NOTIFICATIONS_LOADING = "notification/SET_NOTIFICATIONS_LOADING"
